module.exports = __webpack_public_path__ + "media/42.6f62db98.mp3";